import ReactOnRails from 'react-on-rails';

export default function csrfToken() {
  return ReactOnRails.authenticityToken() ?? '';
}
